import { createAuthProvider } from '@react-keycloak/core';
import { reactKeycloakSsrContext } from './context';
export var KeycloakProvider = createAuthProvider(reactKeycloakSsrContext);
//# sourceMappingURL=KeycloakProvider.js.map